import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import Tabs from 'shared/components/tabs/tabs';
import ViewingMode from 'shared/components/viewing-mode-controller/types/viewing-mode';
import Permission from 'shared/features/auth/authorization/enums/permission';

import {
  DefaultPermissionGroupSettingsApp,
  DefaultPermissionGroupSettingsCentralSupportPortal,
  DefaultPermissionGroupSettingsInsightsPortal,
  DefaultPermissionGroupSettingsPortal,
  PermissionGroupSetting,
} from './permission-group-settings';
import RolePermissionGroupComponent from './role-permission-group-component';

import './role-permissions-component.scss';

interface IProps {
  viewingMode: ViewingMode;
}

const RolePermissionsComponent = (props: Readonly<IProps>): ReactElement => {
  const { t } = useTranslation('permissions');

  const [permissionGroupSettings, setPermissionGroupSettings] = useState<Array<PermissionGroupSetting>>(DefaultPermissionGroupSettingsApp);

  const tabs = [
    {
      value: 0,
      title: t('tabs.App'),
      permission: Permission.ReadRole,
    },
    {
      value: 1,
      title: t('tabs.Portal'),
      permission: Permission.ReadRole,
    },
    {
      value: 2,
      title: t('tabs.CentralSupportPortal'),
      permission: Permission.ReadRole,
    },
    {
      value: 3,
      title: t('tabs.InsightsPortal'),
      permission: Permission.ReadRole,
    },
  ];

  const tabChanged = (tabValue: number): void => {
    switch (tabValue) {
      case 0:
        setPermissionGroupSettings(DefaultPermissionGroupSettingsApp);
        break;
      case 1:
        setPermissionGroupSettings(DefaultPermissionGroupSettingsPortal);
        break;
      case 2:
        setPermissionGroupSettings(DefaultPermissionGroupSettingsCentralSupportPortal);
        break;
      case 3:
        setPermissionGroupSettings(DefaultPermissionGroupSettingsInsightsPortal);
        break;
    }
  };

  return (
    <>
      <div className="role-permissions-tabs">
        <Tabs onTabChanged={tabChanged} tabs={tabs} />
      </div>
      <div data-testid="rolePermissionsComponent" className="role-permissions">
        {permissionGroupSettings.map((setting, index) => (
          <div key={`role-permission-group-${setting.permissionGroup}`}>
            <RolePermissionGroupComponent
              permissionGroup={setting.permissionGroup}
              permissions={setting.permissions}
              icon={setting.icon || <></>}
              viewingMode={props.viewingMode}
            />
            {index !== permissionGroupSettings.length - 1 && <Divider className="role-permission-group-divider" />}
          </div>
        ))}
      </div>
    </>
  );
};

export default RolePermissionsComponent;
